import {
  Grid,
  Button,
  Typography,
  Snackbar,
  IconButton
} from '@material-ui/core'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import AppButton from '../../../components/atoms/AppButton'
import AppLoading from '../../AppLoading'
import { Alert } from '@material-ui/lab'
import { classes } from '../../../utils/css'
import styles from './AppBatteriesManagementDeleteBatteries.module.css'
import BatteriesCsvFile from '../../../assets/formats/delete_batteries_model.csv'
import CloseIcon from '@material-ui/icons/Close'

type AppBatteriesManagementDeleteProps = {
  disableButton: boolean
  isLoading: boolean
  batteriesFile: File | Blob | string
  onFileLoad: (event: React.ChangeEvent<HTMLInputElement>) => void
  onRemoveBatteries: () => void
  snackbar: {
    open: boolean
    onClose?: (event?: React.SyntheticEvent, reason?: string) => void
    body?: ReactElement<any, any>
    duration?: number
    severity?: 'error' | 'warning' | 'info' | 'success'
  }
  inputRef: React.RefObject<HTMLInputElement>
  displayBubbleText: boolean
  onCloseBubbleText: React.Dispatch<React.SetStateAction<boolean>>
}

function AppBatteriesManagementDeleteView({
  disableButton,
  isLoading,
  batteriesFile,
  onFileLoad: handleFile,
  onRemoveBatteries: onImportBatteries,
  snackbar,
  inputRef,
  displayBubbleText,
  onCloseBubbleText
}: AppBatteriesManagementDeleteProps): JSX.Element {
  const { t } = useTranslation()
  return (
    <>
      {isLoading && <AppLoading />}
      <Snackbar
        open={snackbar?.open}
        onClose={snackbar?.onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        className={styles.notification}
        autoHideDuration={snackbar?.duration}
      >
        <Alert
          variant='filled'
          severity={snackbar?.severity}
          onClose={snackbar?.onClose}
        >
          <Grid
            container
            direction='row'
            alignItems='center'
            justify='space-between'
          >
            {snackbar?.body}
          </Grid>
        </Alert>
      </Snackbar>

      <Grid>
        <Grid container className={classes(styles.formContainer)}>
          <Grid item>
            <Grid className={classes(styles.form, styles.field)}>
              <Button
                variant='contained'
                component='label'
                className={classes(
                  batteriesFile != ''
                    ? classes(styles.button, styles.inputUnload)
                    : classes(styles.button, styles.inputLoad)
                )}
              >
                <Typography
                  variant='button'
                  color='secondary'
                  style={{ marginRight: '5px', padding: '10px' }}
                >
                  {t('Upload File ')}
                </Typography>
                <input
                  accept='.csv'
                  type='file'
                  ref={inputRef}
                  placeholder='image'
                  className={classes(styles.hideInput)}
                  onChange={(event) => {
                    handleFile(event)
                  }}
                ></input>
              </Button>
            </Grid>
          </Grid>

          <Grid item>
            <Grid
              container
              direction='row'
              className={classes(styles.form, styles.field)}
            >
              <a href={BatteriesCsvFile} download='batteries_model.csv'>
                {t('Download Model')}
              </a>

              <Grid item className={classes(styles.textBubbleContainer)}>
                <Typography
                  variant='body2'
                  color='secondary'
                  className={classes(
                    styles.textBubble,
                    displayBubbleText ? styles.showBubble : styles.closeBubble
                  )}
                >
                  <IconButton
                    size='small'
                    aria-label='toggle password visibility'
                    onClick={() => onCloseBubbleText(false)}
                    disableRipple={true}
                    edge='end'
                    color='secondary'
                    className={classes(styles.closeIcon)}
                  >
                    <CloseIcon />
                  </IconButton>
                  {t(
                    'If you have doubts about how to make the CSV download the sample template'
                  )}
                  .
                </Typography>
              </Grid>

              <AppButton
                data-testid='deleteButton'
                disabled={disableButton}
                className={classes(styles.button, styles.danger)}
                onClick={onImportBatteries}
              >
                <Typography variant='button' color='secondary'>
                  {t('Remove Batteries')}
                </Typography>
              </AppButton>
            </Grid>
          </Grid>
        </Grid>

        <Typography
          component={'div'}
          variant='body2'
          color='primary'
          className={classes(styles.considerations)}
        >
          <h3>{t('Considerations')}</h3>
          <ol>
            <li>
              - <b>SERIAL:</b> {t('Battery Serial Number')}.
            </li>
          </ol>
        </Typography>
      </Grid>
    </>
  )
}

export default AppBatteriesManagementDeleteView
